// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tH3Pk","index":"styles_index__15CK5"};